import { render, staticRenderFns } from "./PersonalizedRanking.vue?vue&type=template&id=80c8a666&"
import script from "./PersonalizedRanking.vue?vue&type=script&lang=js&"
export * from "./PersonalizedRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports